( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function PpdModalCtrl ( $scope, $modalInstance, ppdSource, options, resource, PPD_MESSAGES, ppdFactory ) {
		var self = this;

		self.readOnly = options.readOnly;

		function initializeData () {
			self.active = 0;
			self.navs   = ppdFactory.setNavs( options.location );

			ppdFactory.setOptions( options );
			ppdFactory.setResource( resource );
			ppdFactory.setBaseCollection( ppdSource );

			// data for readOnly
			self.attachedPDs = ppdFactory.getAttachedPDs();
		}

		function close () {
			$modalInstance.dismiss();
		}

		function activate () {
			initializeData();
		}

		self.close = close;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'PpdModalCtrl', PpdModalCtrl );

	PpdModalCtrl.$inject = [ '$scope', '$modalInstance', 'ppdSource', 'options', 'resource', 'PPD_MESSAGES', 'ppdFactory' ];
} )( );
